import { BrowserRouter, Route, Routes } from "react-router-dom";
import SiteLayout from "@/SiteLayout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import CoveragesPage from "@/pages/CoveragesPage";
import InvestorPage from "@/pages/InvestorPage";
import GalleryPage from "@/pages/GalleryPage";
import { LanguageProvider } from "@/i18n";

export default function App() {
  return <LanguageProvider><BrowserRouter>
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<AboutPage />} />
        <Route path="/coverages" element={<CoveragesPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/investor" element={<InvestorPage />} />
      </Route>
    </Routes>
  </BrowserRouter></LanguageProvider>;
}
